module.exports = __webpack_public_path__ + "static/img/1.322b96d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/zh/1.png
// module id = 5Sla
// module chunks = 0